import * as React from 'react';
import CompetitionDetailsProps from './type';
import { Container } from '../helpers/Grid';
// import LocalizationContext from '../../contexts/Localizations';
import './styles.scss';

const CompetitionDetails = ({
  competitionClass,
  venue,
  country,
  dates,
  email,
  name,
  website,
  classLabel,
  emailLabel,
  websiteLabel,
}: CompetitionDetailsProps) => (
  <section className="competition-details">
    <Container>
      <div className="competition-details__inner">
        <header className="competition-details__header">
          <div className="competition-details__name">
            <h1>{name}</h1>
          </div>
          <div className="competition-details__venue">
            {venue && `${venue}, `}
            {country}
          </div>
          <div className="competition-details__dates">
            {dates}
          </div>
        </header>
        <div className="competition-details__group">
          {competitionClass && (
            <div className="competition-details__group-item">
              <span>{classLabel}</span>
              {competitionClass}
            </div>
          )}
          {website && (
            <div className="competition-details__group-item">
              <span>{websiteLabel}</span>
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <a
                href={website.url}
                target={website.isExternal ? '_blank' : '_self'}
                rel={website.isExternal ? 'noopener noreferrer' : ''}
              >
                {website.title}
              </a>
            </div>
          )}
          {email && (
            <div className="competition-details__group-item">
              <span>{emailLabel}</span>
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <a
                href={email.url}
                target={email.isExternal ? '_blank' : '_self'}
                rel={email.isExternal ? 'noopener noreferrer' : ''}
              >
                {email.title}
              </a>
            </div>
          )}
        </div>
      </div>
    </Container>
  </section>
);

export default CompetitionDetails;
